import { render } from "./WarehouseStockManagement.vue?vue&type=template&id=ce0f16d8&scoped=true"
import script from "./WarehouseStockManagement.vue?vue&type=script&lang=js"
export * from "./WarehouseStockManagement.vue?vue&type=script&lang=js"

import "./WarehouseStockManagement.vue?vue&type=style&index=0&id=ce0f16d8&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce0f16d8"]])

export default __exports__